/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, color, textShadow } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// CLOSE STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	close: {
		position: 'absolute',
		top: pxToEm(-15),
		right: pxToEm(5),
		zIndex: '11',

		animationName: 'rotateIn',
		animationDuration: '.6s',
		animationDelay: '0s',
        animationFillMode: 'forwards',
		
		'& .icon': {
			color: color.white,
			cursor: 'pointer',
			display: 'block',
			fontSize: pxToEm(40),
			extend: textShadow.spread,
			transform: 'rotate(46deg)'
		}
	}
};